import { Injectable } from '@angular/core';
import { Storage } from '@ionic/storage';

import { HelpersUtil } from 'src/app/shared/utils/helpers.util';

@Injectable({
  providedIn: 'root'
})
export class StorageService {
  constructor(private storage: Storage) {  
    this.init();
  }

  private async init() {
    await this.storage.create();
  }

  async clear() {
    await this.storage.clear();
  }

  async get(key: string) {
    const encodedData = await this.storage.get(key);

    if (encodedData) {
      return HelpersUtil.decode(encodedData);
    }
    
    return null;
  }

  async isExist(key: string) {
    return !!(await this.storage.get(key));
  }

  async remove(key: string) {
    await this.storage.remove(key);
  }

  async set(key: string, value: any) {
    const encodedValue = HelpersUtil.encode(value);

    await this.storage.set(key, encodedValue);
  }
}
